export default "__VITE_ASSET__eb0aa4f6__"